import HuntingWordsGeneratorRoot from './Root.vue';
import HuntingWordsCreate from './views/HuntingWordsCreate.vue';
import HuntingWordsEdit from './views/HuntingWordsEdit.vue';
import HuntingWordsList from './views/HuntingWordsList.vue';

export default {
  path: 'gerador/caca-palavras',
  name: 'hunting-words-generator',
  component: HuntingWordsGeneratorRoot,
  redirect: '/novo',
  children: [
    {
      path: 'lista/:page',
      name: 'admin-hunting-words-list',
      component: HuntingWordsList,
    },
    {
      path: 'novo/',
      name: 'admin-hunting-words-new',
      component: HuntingWordsCreate,
    },
    {
      path: ':puzzleId',
      name: 'admin-hunting-words-edit',
      component: HuntingWordsEdit,
    },
  ],
};
